import React from 'react';
import styled from 'styled-components';
import GooglePlayLogo from '../../../assets/logos/google-play';
import AppleAppStoreLogo from '../../../assets/logos/apple-app-store';

const Container = styled.div`
  max-width: 440px;
  margin-top: 46px;

  color: black;
`;

const Buttons = styled.div`
  display: none;
  margin-top: 16px;

  a:first-of-type {
    margin-right: 16px;
  }

  @media screen and (max-width: ${(props) => props.theme.widths.max1024}) {
    display: flex;
    justify-content: start;

    margin-bottom: 16px;
  }

  @media screen and (max-width: ${(props) => props.theme.widths.max768}) {
    display: flex;
    justify-content: space-evenly;

    margin-bottom: 16px;
    margin-top: 0;
  }
`;

const QRContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: 6px;
  background-color: #fcfcfd;
  padding: 12px 16px;

  @media screen and (max-width: ${(props) => props.theme.widths.max768}) {
    display: none;
  }
`;

const QRDescription = styled.div`
  display: flex;
  height: 100%;
  align-content: center;
  margin-left: 16px;

  p {
    color: #000000;
    font-weight: 400;
    size: 32px;
  }
`;

const StoreButtons = ({ children }) => (
  <Container>
    <QRContainer>
      {children}

      <QRDescription>
        <p>Download the mobile app for a better experience by scanning with your device.</p>
      </QRDescription>
    </QRContainer>
    <Buttons>
      <a
        target="_blank"
        href="https://play.google.com/store/apps/details?id=com.borrowermobileapp"
        rel="noreferrer noopener"
        aria-label="Link to google play app"
      >
        <GooglePlayLogo />
      </a>
      <a
        target="_blank"
        href="https://apps.apple.com/za/app/prodigy-finance/id1328183408"
        rel="noreferrer noopener"
        aria-label="Link to apple store app"
      >
        <AppleAppStoreLogo />
      </a>
    </Buttons>
  </Container>
);

export default StoreButtons;
